<ngx-loading-bar [includeSpinner]="false" height="4px" [color]="'#ffcc00'"></ngx-loading-bar>
<router-outlet></router-outlet>
<app-resume-onboarding-modal [user]="user"></app-resume-onboarding-modal>
<div class="d-none">{{null|pdate}}</div>
<div class="text-center opacity-50 red-bg f-white" dir="ltr"
  style="position: fixed;bottom: 0; left: 0; height: 40px; z-index: 10000" *ngIf="env == 'dev' || env == 'staging'"
  [style.width]="(expandDebug ? '100%' : '20px')" (click)="expandDebug=!expandDebug">
  ..:: {{env}} Environment ::..
  --
  <span class="pointer" (click)="appService.checkForUpdatesNow()"> Update Now </span>
  --
  <span title="messaging/permission"> {{pushService.status$|async}} </span>
  --
  <span title="log"> {{Utility.log|json}} </span>
</div>
<app-dynamic-loader></app-dynamic-loader>
<div class="d-none">
  <button class="btn btn-secondary " (click)="appService.checkForUpdatesNow()">update app now</button>
  <button class="btn btn-secondary" (click)="valuesService.request()">check request</button>
  <button class="btn btn-secondary" (click)="valuesService.error()"> Raise Error </button>
</div>
